import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ProgressProvider } from './contexts/ProgressContext';
import FrontCover from './pages/FrontCover';
import ChapterList from './pages/ChapterList';
import Lesson from './pages/Lesson';
import PracticeTest from './pages/PracticeTest';
import './App.css';

export default function App() {
  return (
    <ProgressProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FrontCover />} />
          <Route path="/chapter/:chapterId" element={<ChapterList />} />
          <Route path="/chapter/:chapterId/:subChapterId" element={<ChapterList />} />
          <Route path="/lesson/:testIdentifier/:lessonIndex" element={<Lesson />} />
          <Route path="/test/:testIdentifier" element={<PracticeTest mode="practice" />} />
          <Route path="/rehearsal-test/:testIdentifier" element={<PracticeTest mode="rehearsal" />} />
        </Routes>
      </BrowserRouter>
    </ProgressProvider>
  );
}
